import React from 'react';

class WaitAnimation extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        return (
            <div style={{
                display: this.props.waiting ? 'flex' : 'none',
                alignItems: 'center',
                padding: '5px',
                height: '40px',
            }}>
                <img 
                    src="wait2.gif" 
                    alt={this.props.animationMessage}
                    height="25" 
                    width="25" 
                    style={{marginRight: '10px'}}
                />
                <span>{this.props.animationMessage} {this.props.waitCount}</span>
            </div>
        );
    }
}

export default WaitAnimation;